// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.game-slide[data-v-4c7b5199] {\n  transition: opacity 0.3s ease;\n}\n.game-slide.dimmed[data-v-4c7b5199] {\n  opacity: 0.3;\n}\n.game-slide.hovered[data-v-4c7b5199] {\n  opacity: 1;\n  z-index: 2;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
